import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { HpmReportsFilter } from 'libs/domain';
import { ReportTypes } from 'libs/domain';
import { ColumnInfo, TemplateColumnKeys, HallPassReportColumns } from 'libs/shared';

import { ReportDatasourceService } from '@app/src/app/components/manager-report/services/report-datasource.service';

import { HpmReportsService } from '../services';

@Injectable()
export class HpmReportsCreatorsService extends ReportDatasourceService<any> {
  historyInfo = {
    filter: HpmReportsFilter.ISSUED_BY,
    url: '/hall-pass/reports/' + ReportTypes.HALL_PASS_HISTORY,
  };
  summaryInfo = {
    filter: HpmReportsFilter.ISSUED_BY,
    url: '/hall-pass/reports/' + ReportTypes.HALL_PASS_SUMMARY,
  };

  /** Service Constructor */
  constructor(private _hpmReports: HpmReportsService, _router: Router) {
    super(_router, _hpmReports, HpmReportsCreatorsService.name);
    const displayCol: ColumnInfo[] = [
      {
        header: '',
        key: TemplateColumnKeys.SUMMARY,
        columnClasses: ['w-16'],
      },
      {
        header: '',
        key: TemplateColumnKeys.HISTORY,
        columnClasses: ['w-16'],
      },
    ];
    super.setDisplayColumns(HallPassReportColumns.STAFF, displayCol);
  }

  async fetch(offset: number, limit: number) {
    return await this._hpmReports.getCreators(offset, limit, this._currentSort);
  }
}
